/* eslint-disable no-nested-ternary */
import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Divider,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Grid,
    MenuItem,
    Paper,
    TextField,
    Typography,
    useMediaQuery
} from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useMessageDispatcher from 'hooks/useMessageDispatcher';
import axios from 'axios';
import MainCard from 'ui-component/cards/MainCard';

const headers = {
    headers: {
        Authorization: `Bearer ${window.localStorage.getItem('serviceToken') || window.localStorage.getItem('webViewToken')}`,
        'Content-Type': 'application/json'
    }
};

const LabelledField = ({ label, children }) => (
    <Box mb={1}>
        <Typography fontSize="0.85rem" fontWeight="bold" mb={0.5}>
            {label}
        </Typography>
        {children}
    </Box>
);

const CustomTextField = (props) => (
    <TextField
        variant="outlined"
        fullWidth
        size="small"
        InputProps={{
            style: {
                border: '1px solid black',
                borderRadius: 0,
                padding: 0,
                fontSize: '0.85rem'
            }
        }}
        sx={{
            bgcolor: '#fff',
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    border: '1px solid black',
                    borderRadius: 0
                },
                '&:hover fieldset': {
                    border: '1px solid black'
                },
                '&.Mui-focused fieldset': {
                    border: '1px solid black'
                }
            }
        }}
        {...props}
    />
);
const category = ['General', 'SC', 'ST', 'OBC', 'Minority', 'Others'];
const NSSCell = () => {
    const location = useLocation();
    const studentData = location.state?.studentData;
    const [signature, setSignature] = useState('');
    const isMobile = useMediaQuery('(max-width:600px)');
    const currentDate = moment().format('YYYY-MM-DD');
    const showMessage = useMessageDispatcher();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [nssInfo, setNssInfo] = useState({
        hobbies: studentData?.nssInfo?.hobbies || [],
        languages: studentData?.nssInfo?.languages || [],
        acceptTerms: studentData?.nssInfo?.acceptTerms || false
    });
    const formatAddress = (data) => {
        const { houseNo, street, district, city, state, zip, country } = data;
        const parts = [];

        if (houseNo?.trim()) parts.push(`House No. ${houseNo.trim()}`);
        parts.push(
            street.trim(),
            district.trim().toLowerCase() !== city.trim().toLowerCase() ? district.trim() : null,
            city.trim(),
            state.trim(),
            zip.trim(),
            country.trim()
        );

        return parts.filter(Boolean).join(', ');
    };
    const tempAddress = formatAddress(studentData?.temporaryAddress);
    const permanentAddress = formatAddress(studentData?.permanentAddress);
    const handleHobbyChange = (event) => {
        const { checked, value } = event.target;
        setNssInfo((prevState) => {
            const newHobbies = checked ? [...prevState.hobbies, value] : prevState.hobbies.filter((hobby) => hobby !== value);

            return { ...prevState, hobbies: newHobbies };
        });
    };
    const handleLanguageChange = (index, value) => {
        setNssInfo((prevState) => {
            const newLanguages = [...prevState.languages];
            newLanguages[index] = value?.toUpperCase();
            return { ...prevState, languages: newLanguages };
        });
    };
    const handleAcceptTermsChange = (event) => {
        setNssInfo((prevState) => ({
            ...prevState,
            acceptTerms: event.target.checked
        }));
    };
    const fetchSignature = async (fileName) => {
        axios.post(`/v1/utils/file/download`, { fileName }, headers).then((result) => {
            setSignature(result.data.data);
        });
    };
    const handleSubmit = () => {
        const errors = [];

        if (!nssInfo.hobbies || nssInfo.hobbies.length === 0) {
            errors.push('Please select at least one hobby.');
        }

        const filledLanguages = nssInfo.languages?.filter((lang) => lang?.trim() !== '') || [];
        if (filledLanguages.length === 0) {
            errors.push('Please enter at least one language.');
        }

        if (!nssInfo.acceptTerms) {
            errors.push('You must accept the declaration to proceed.');
        }
        if (errors.length > 0) {
            showMessage({ message: errors[0], type: 'error' });
            return;
        }
        setIsLoading(true);
        axios
            .post(`/v1/student/update-nss-info?studentId=${studentData?.id}`, nssInfo, headers)
            .then((response) => {
                navigate(-1);
                setIsLoading(false);
                if (response.status === 200) {
                    showMessage({ message: 'NSS Form submitted successfully', type: 'success' });
                }
            })
            .catch((error) => {
                setIsLoading(false);
                if (!error.response) {
                    showMessage({ message: error.message, type: 'error' });
                } else {
                    showMessage({ message: error.response.data.Msg, type: 'error' });
                }
            });
    };
    useEffect(() => {
        if (studentData?.studentSignature || studentData?.declarations[0]?.signatureFile)
            fetchSignature(studentData.studentSignature || studentData?.declarations[0]?.signatureFile);
    }, []);

    const PhotoBlock = () => (
        <Box
            sx={{
                width: '100%',
                height: isMobile ? 'auto' : '100%',
                minHeight: 170,
                border: '1px solid grey',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                mb: isMobile ? 2 : 0
            }}
        >
            {studentData?.studentPhoto ? (
                <img
                    src={studentData?.studentPhoto}
                    alt="Student"
                    style={{
                        width: '100%',
                        height: '100%',
                        border: '1px solid #ccc',
                        borderRadius: 4
                    }}
                />
            ) : (
                <Typography fontSize="0.85rem" textAlign="center" fontWeight="bold">
                    Affix latest <br /> passport size <br /> photograph
                </Typography>
            )}
        </Box>
    );

    return (
        <MainCard>
            <Paper elevation={3} sx={{ p: 4, maxWidth: 900, mx: 'auto', my: 4, bgcolor: '#cbc5b4', color: '#282b4f' }}>
                <Box textAlign="center" mb={3} sx={{ color: '#282b4f', fontWeight: 'bold' }}>
                    <img
                        src="/UniversityHeader.png"
                        alt="University Header"
                        style={{ maxWidth: '100%', height: 'auto', display: 'block' }}
                    />
                    <Typography variant="subtitle2">Accredited &apos;A&apos; Grade by NAAC</Typography>
                    <Typography variant="h3" mt={2} fontWeight={600}>
                        National Service Scheme (NSS) Cell
                    </Typography>
                    <Typography width={isMobile ? '100%' : '40%'} m="auto" border="3px solid" variant="h4" mt={2} py={1}>
                        Application Form for NSS Volunteer
                    </Typography>
                </Box>

                <Grid container spacing={2}>
                    {isMobile && (
                        <Grid item xs={12}>
                            <PhotoBlock />
                        </Grid>
                    )}
                    <Grid item xs={isMobile ? 12 : 9}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <LabelledField label="Name of the Student (In Capital)">
                                    <CustomTextField value={studentData?.studentName} />
                                </LabelledField>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <LabelledField label="Date of Birth">
                                    <CustomTextField value={studentData?.personalDetails?.dob} type="date" />
                                </LabelledField>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <LabelledField label="Blood Group">
                                    <CustomTextField value={studentData?.personalDetails?.bloodGroup} />
                                </LabelledField>
                            </Grid>
                            <Grid item xs={12}>
                                <LabelledField label="Father's/ Guardian's Name">
                                    <CustomTextField value={studentData?.fatherDetails?.name} />
                                </LabelledField>
                            </Grid>
                        </Grid>
                    </Grid>
                    {!isMobile && (
                        <Grid item xs={3}>
                            <PhotoBlock />
                        </Grid>
                    )}
                    <Grid item xs={12} md={6}>
                        <LabelledField label="Gender">
                            <CustomTextField select value={studentData?.personalDetails?.gender}>
                                <MenuItem value="Male">Male</MenuItem>
                                <MenuItem value="Female">Female</MenuItem>
                            </CustomTextField>
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <LabelledField label="Caste Category">
                            <CustomTextField select value={studentData?.personalDetails?.caste}>
                                {category.map((c) => (
                                    <MenuItem key={c} value={c}>
                                        {c}
                                    </MenuItem>
                                ))}
                            </CustomTextField>
                        </LabelledField>
                    </Grid>{' '}
                    <Grid item xs={12} md={6}>
                        <LabelledField label="Course">
                            <CustomTextField value={studentData?.courseDetail?.course?.courseName} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <LabelledField label="Year of Admission">
                            <CustomTextField value={studentData?.courseDetail?.academicYear?.startYear} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <LabelledField label="Department">
                            <CustomTextField value={studentData?.courseDetail?.course?.departmentMini?.name} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <LabelledField label="Semester">
                            <CustomTextField value={studentData?.courseDetail?.currentSemester} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <LabelledField label="Enrollment Number">
                            <CustomTextField value={studentData?.enrollmentNo} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <LabelledField label="Roll No.">
                            <CustomTextField value={studentData?.rollNo} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12}>
                        <LabelledField label="Background (Urban/ Rural)">
                            <CustomTextField value={studentData?.personalDetails?.locality} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <LabelledField label="Permanent Address">
                            <CustomTextField multiline rows={3} value={permanentAddress} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <LabelledField label="Correspondence Address">
                            <CustomTextField multiline rows={3} value={tempAddress} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <LabelledField label="Email ID">
                            <CustomTextField value={studentData?.personalDetails?.email} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <LabelledField label="Mobile No.">
                            <CustomTextField value={studentData?.personalDetails?.phone} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12}>
                        <FormLabel component="legend" sx={{ fontWeight: 'bold', fontSize: '0.85rem', mb: 0.5 }}>
                            Hobbies
                        </FormLabel>{' '}
                        <FormGroup row>
                            {['Cultural Activities', 'Literary Activities', 'Social Services', 'Sports', 'Other Activities'].map(
                                (hobby) => (
                                    <FormControlLabel
                                        key={hobby}
                                        control={
                                            <Checkbox
                                                value={hobby}
                                                sx={{ color: 'black', '&.Mui-checked': { color: 'black' } }}
                                                checked={nssInfo.hobbies.includes(hobby)}
                                                onChange={handleHobbyChange}
                                            />
                                        }
                                        label={hobby}
                                    />
                                )
                            )}
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12}>
                        <FormLabel component="legend" sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>
                            Languages Known
                        </FormLabel>
                    </Grid>
                    {['Language 1', 'Language 2', 'Language 3']?.map((language, index) => (
                        <Grid item xs={12} md={4} key={language}>
                            <LabelledField label={language}>
                                <TextField
                                    value={nssInfo.languages[index] || ''}
                                    onChange={(e) => handleLanguageChange(index, e.target.value)}
                                    fullWidth
                                />
                            </LabelledField>
                        </Grid>
                    ))}
                    <Grid item xs={12} mt={2} display="flex" alignItems="center">
                        <Checkbox
                            sx={{ color: 'black', '&.Mui-checked': { color: 'black' } }}
                            checked={nssInfo.acceptTerms}
                            onChange={handleAcceptTermsChange}
                        />
                        <Typography>
                            <em>
                                I hereby declare that the above-mentioned particulars are true and correct. If I am admitted to NSS, I will
                                abide, adhere & promote the values of NSS.
                            </em>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <LabelledField label="Date">
                            <CustomTextField value={currentDate} type="date" />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} md={6} textAlign={isMobile ? 'center' : 'right'}>
                        {(studentData?.studentSignature || studentData?.declarations[0]?.signatureFile) && (
                            <Box display={isMobile ? 'block' : 'flex'} justifyContent="flex-end">
                                <img
                                    src={signature || studentData?.declarations[0]?.signatureFile}
                                    alt="Student"
                                    style={{
                                        maxWidth: '100%',
                                        width: '200px',
                                        height: 'auto',
                                        border: '1px solid #ccc',
                                        borderRadius: 4
                                    }}
                                />
                            </Box>
                        )}
                        <Typography>Signature of the Student</Typography>
                    </Grid>
                </Grid>
                <Box mt={4} display="flex" justifyContent={isMobile ? 'center' : 'flex-end'}>
                    <Button
                        disabled={isLoading}
                        startIcon={isLoading && <CircularProgress size="1rem" sx={{ color: 'red' }} />}
                        variant="contained"
                        color="secondary"
                        onClick={() => handleSubmit()}
                    >
                        {isLoading ? 'Please Wait' : studentData?.nssInfo?.acceptTerms ? 'Update' : 'Submit'}
                    </Button>
                </Box>
                <Divider sx={{ my: 3 }} />

                <Typography variant="h5" textAlign="center" mt={1}>
                    NSS Cell, University of Science & Technology, Meghalaya
                    <br />
                    Contact No. 0361-2895030 / 9401440015 / 09854023060, Email: ustmnss@gmail.com
                </Typography>
            </Paper>
        </MainCard>
    );
};

export default NSSCell;
